import React, { useEffect } from "react";
import { NavLink } from "react-router-dom";

const Help = () => {
  return (
    <div>
      <div className="text-center">
        <div style={{ "margin-top": "40%" }}>
          <img
            src={require("../../images/ico.png")}
            height="100px"
            width="100px"
            class="rounded"
            alt="..."
          />
        </div>
        <NavLink to="/contact" className="btn ml-4 mr-4 btn-success mt-2">
          CONTACT STATION MANAGER
        </NavLink>
        <div className="mt-4">
          {" "}
          <a
            style={{ color: "#74aabb" }}
            href={process.env.REACT_APP_ELUTAG_WEBSITE}
          >
            www.eluTAG.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default Help;
